import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "src/react/components/link";

function TermsAndConditionsSmallPrint({ buttonText = "Continue" }) {
  return (
    <Wrapper>
      By clicking {buttonText}, you are providing consent to our{" "}
      <CustomLink inline to="/terms-and-conditions">
        T&Cs
      </CustomLink>{" "}
      and{" "}
      <CustomLink inline to="/privacy-policy">
        Privacy Policy
      </CustomLink>
    </Wrapper>
  );
}

TermsAndConditionsSmallPrint.propTypes = {
  buttonText: PropTypes.string,
};

export default TermsAndConditionsSmallPrint;

const Wrapper = styled.p`
  text-align: center;
  font-size: 12px;
  line-height: 1.45em;
  padding: 2em 0 1em;
  margin-bottom: 0;
`;

const CustomLink = styled(Link)`
  font-size: 12px;
`;
